import { CoreAdvertiser } from "@core/store/modules/advertiser";
import { RootState } from "@core/store/root-state";

export class Advertiser extends CoreAdvertiser<RootState, RootState> {
  constructor () {
    super();
    
    this.modules({});
  }
}